import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles
} from '@material-ui/core';

import {useSelectedSubNavTab} from "../utils/CustomHooks";
import TrendingTopics from "./TrendingTopics";
import StudentSentiment from "./StudentSentiment";
import NationalStudentSentiment from "./NationalStudentSentiment";
import TrendsTabs from "../components/TrendsTabs";
import SubNavPanelsWrapper from "../components/SubNavPanelsWrapper";

const styles = makeStyles(theme => ({
	fullScreenClassName: {
		[theme.breakpoints.only('md')]: {
			paddingTop: `${theme.spacing(28.125)}px !important`
		}
	}
}));

function Trends(props) {
	const [selectedTab, setSelectedTab] = useState(false);
	const tabs = ["topics", "student-sentiment", "national-student-sentiment"];

	let classes = styles(),
		{history, location, updateHeader, resetHeader,
			setFullScreenClassName, setBannerClassName, showSnackbar, hasNudgeBanner} = props,
		fullScreenClassName = classes.fullScreenClassName;

	const getSelectedTab = useSelectedSubNavTab(location, tabs);

	useEffect(() => {
		updateHeader({title: "trends", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	useEffect(() => {
		setSelectedTab(getSelectedTab());
	}, [getSelectedTab, setSelectedTab]);

	useEffect(() => {
		setFullScreenClassName(fullScreenClassName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const tabClicked = (event, tab) => {
		setSelectedTab(tab);
		props.history.push(`/trends/${tab}`);
	};

	return (
		<React.Fragment>
			<TrendsTabs
				selectedTab={selectedTab}
				tabClicked={tabClicked}
				hasNudgeBanner={hasNudgeBanner}
				setBannerClassName={setBannerClassName} />
			<SubNavPanelsWrapper>
				{selectedTab === tabs[0] ?
					<TrendingTopics
						history={history}
						location={location}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} /> : null
				}
				{selectedTab === tabs[1] ?
					<StudentSentiment
						location={location}
						showSnackbar={showSnackbar}
						updateHeader={updateHeader}
						resetHeader={resetHeader} /> : null
				}
				{selectedTab === tabs[2] ?
					<NationalStudentSentiment
						location={location}
						showSnackbar={showSnackbar}
						updateHeader={updateHeader}
						resetHeader={resetHeader} /> : null
				}
			</SubNavPanelsWrapper>
		</React.Fragment>
	);
}

Trends.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default Trends;